module.exports = __webpack_public_path__ + "malawi.svg?5842e772234e7e960d4abe8a2024ffee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/malawi.svg
// module id = 221
// module chunks = 10